import { omit, cloneDeep } from 'lodash';
import { ELSLoggingService } from '@els/els-ui-common-react';
import { RecordObject } from '../models/common.models';

const fileName = 'error.utilities';

const getBrowserDetails = (): RecordObject => omit(cloneDeep(navigator), 'mimeTypes');

export const logError = ({ err, previousState, previousStateParams }: { err: Error; previousState?: unknown; previousStateParams?: unknown }): void => {
  const details = {
    error: err,
    browser: getBrowserDetails(),
    previousState,
    previousStateParams
  };
  ELSLoggingService.error(fileName, details);
};

export const promiseErrorHandler = (error: Error): { data: unknown[] } => {
  ELSLoggingService.error(fileName, `Invoke service error: ${error.message}`, error);
  return { data: [] };
};

export const errorUtils = { logError, promiseErrorHandler };
